// extracted by mini-css-extract-plugin
export default {"borderVertical":"borderVertical--Oc9YD","borderHorizontal":"borderHorizontal--v3WGu"};